<script>
import DisplayExecutionSchema from '@/components/execution/DisplayExecutionSchema.vue'
import JobScheduleCalendar from '@/components/bot-scheduler/JobScheduleCalendar.vue'
import { mapGetters, mapState } from 'vuex'
import _ from 'lodash'
import moment from 'moment/moment'
import cronstrue from 'cronstrue'

export default {
  name: 'JobCard',
  components: { DisplayExecutionSchema, JobScheduleCalendar },
  props: {
    jobSchedule: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    loader: false,
    showUserInputs: false,
    showCalender: false
  }),
  mounted() {
    this.getData()
  },
  computed: {
    ...mapGetters({
      can: 'can'
    })
  },
  methods: {
    format(input) {
      return _.capitalize(_.startCase(input))
    },
    getLocalTime(input) {
      return moment(input)
        .utc()
        .local()
        .format('DD MMM YYYY, hh:mm:ss a')
    },
    getCronMessage(input) {
      return cronstrue.toString(input)
    },
    getData() {}
  }
}
</script>

<template>
  <v-layout row wrap>
    <v-flex xs12 class="pa-2">
      <v-card
        :loading="loader"
        flat
        :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
      >
        <v-card-title>
          <span class="body-1 beez-bold">
            Job details
          </span>
        </v-card-title>
        <v-card-text v-if="jobSchedule">
          <v-layout row wrap>
            <v-flex xs12 md6 lg4>
              <div class="text-xs-left">
                <br />
                <div>Created By</div>
                <div class="subheading">
                  {{ jobSchedule.createdByName }}
                </div>
                <br />
              </div>
            </v-flex>
            <v-flex xs12 md6 lg4>
              <div class="text-xs-left">
                <br />
                <div>Created At</div>
                <div class="subheading">
                  {{ getLocalTime(jobSchedule.createdAt) }}
                </div>
                <br />
              </div>
            </v-flex>
            <v-flex xs12 md6 lg4>
              <div class="text-xs-left">
                <br />
                <div>Last Updated By</div>
                <div class="subheading">
                  {{ jobSchedule.changedByName }}
                </div>
                <br />
              </div>
            </v-flex>
            <v-flex xs12 md6 lg4>
              <div class="text-xs-left">
                <br />
                <div>Last Updated At</div>
                <div class="subheading">
                  {{ getLocalTime(jobSchedule.changedAt) }}
                </div>
                <br />
              </div>
            </v-flex>
            <v-flex xs12 md6 lg4>
              <div class="text-xs-left">
                <br />
                <div>Scheduled service type</div>
                <div class="subheading text-capitalize">
                  {{ format(jobSchedule.executionType) }}
                </div>
                <br />
              </div>
            </v-flex>
            <v-flex xs12 md6 lg4>
              <div class="text-xs-left">
                <br />
                <div>Scheduled service name</div>
                <div class="subheading">
                  {{ jobSchedule.serviceName }}
                </div>
                <br />
              </div>
            </v-flex>
            <v-flex xs12 md6 lg4>
              <div class="text-xs-left">
                <br />
                <div>Scheduled service description</div>
                <div class="subheading">
                  {{ jobSchedule.serviceDescription }}
                </div>
                <br />
              </div>
            </v-flex>
            <v-flex xs12>
              <div class="text-xs-left">
                <br />
                <div
                  class="subheading orange--text"
                  v-if="jobSchedule.cronExpression"
                >
                  Recurring Schedule Runs
                  {{ getCronMessage(jobSchedule.cronExpression) }}
                </div>
                <div
                  class="subheading orange--text"
                  v-else-if="jobSchedule.jobScheduleTime"
                >
                  Runs Once At {{ getLocalTime(jobSchedule.jobScheduleTime) }}
                </div>
                <br />
              </div>
            </v-flex>
            <v-flex xs12>
              <v-card flat>
                <v-toolbar dense flat @click="showUserInputs = !showUserInputs">
                  <v-toolbar-title class="body-1 beez-bold">
                    User Inputs
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon @click.stop="showUserInputs = !showUserInputs">
                    <v-icon
                      >{{
                        showUserInputs
                          ? 'keyboard_arrow_up'
                          : 'keyboard_arrow_down'
                      }}
                    </v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text v-if="showUserInputs">
                  <display-execution-schema
                    v-if="
                      jobSchedule.botExchangeModel &&
                        jobSchedule.botExchangeModel.botInputs
                    "
                    :input="jobSchedule.botExchangeModel.botInputs"
                  />
                  <display-execution-schema
                    v-else-if="
                      jobSchedule.workflowExecutionModel &&
                        jobSchedule.workflowExecutionModel.workflowVariables
                    "
                    :input="
                      jobSchedule.workflowExecutionModel.workflowVariables
                    "
                  />
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 class="mt-2">
              <v-card :loading="loader" flat>
                <v-toolbar dense flat @click="showCalender = !showCalender">
                  <v-toolbar-title class="body-1 beez-bold">
                    Job Schedule Calender
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon @click.stop="showCalender = !showCalender">
                    <v-icon
                      >{{
                        showCalender
                          ? 'keyboard_arrow_up'
                          : 'keyboard_arrow_down'
                      }}
                    </v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text v-if="showCalender">
                  <job-schedule-calendar :job-schedule="jobSchedule" />
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="jobSchedule"
            flat
            :loading="loader"
            :color="$vuetify.dark ? 'secondary' : ''"
            :outline="$vuetify.dark"
            class="text-capitalize mx-2"
            :to="{
              name:
                jobSchedule.executionType === 'BOT'
                  ? 'bot-detail'
                  : 'workflow-detail',
              params: { hexId: jobSchedule.executableId }
            }"
          >
            <v-icon>
              link
            </v-icon>
            <span class="pl-2">Go To Service</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<style scoped></style>
